import React, { useEffect, useRef, useState, useCallback } from 'react';
import MDropdownView from './MDropdown.view';
import { IDropdownListOption } from '../MSelectList/MSelectList.model';

interface Props<ValueType extends string | number> {
  className?: string;
  options: IDropdownListOption<ValueType>[];
  onClickOption: (optionIndex: number) => void;
}

const MDropdown = <ValueType extends string | number>(props: React.PropsWithChildren<Props<ValueType>>): JSX.Element => {
  const [listState, setListState] = useState<boolean>(false);

  const listRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (listState && listRef.current) {
      const checkClick = (event: MouseEvent) => {
        if (listRef.current && listRef.current !== event.target && !listRef.current.contains(event.target as HTMLElement)) {
          setListState(() => false);
        }
      };

      document.addEventListener('click', checkClick);

      return () => {
        document.removeEventListener('click', checkClick);
      };
    }
  }, [listRef.current, listState, setListState]);

  const setSelectedOption = useCallback(
    (value: string | number) => {
      setListState(() => false);
      props.onClickOption(value as number);
    },
    [setListState],
  );

  return (
    <MDropdownView
      className={props.className}
      showList={listState}
      listRef={listRef}
      onOptionClick={setSelectedOption}
      options={props.options}
      onShowList={() => setListState(() => true)}
    >
      {props.children}
    </MDropdownView>
  );
};

MDropdown.displayName = 'MDropdown';
MDropdown.defaultProps = {};

export default MDropdown;
